import { useSyncExternalStore } from 'react';

// „Can we reach the server?” — fed by the API client (a request that never
// got an answer / the next one that did) and by the browser's online events.
let isReachable = typeof navigator === 'undefined' ? true : navigator.onLine;
const listeners = new Set<() => void>();

export function reportNetworkState(reachable: boolean): void {
  if (reachable === isReachable) return;
  isReachable = reachable;
  listeners.forEach((listener) => listener());
}

if (typeof window !== 'undefined') {
  window.addEventListener('offline', () => reportNetworkState(false));
  window.addEventListener('online', () => reportNetworkState(true));
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useIsServerReachable(): boolean {
  return useSyncExternalStore(subscribe, () => isReachable, () => true);
}
